import React from "react";
import '../aboutme/aboutme.css';
export default function AboutMe(){
    return(
        <div className="aboutmeContainer">
            <h1 className="aboutmeH1">Hi, I'm Marco. Nice to meet you.</h1>
            <p className="aboutmeP">Since beginning my journey as a Developer over 5 years ago, I've done remote work <br/>
            for agencies, consulted for startups, and collaborated with talented people to create <br/>
            Web Applications, Resful Web Services, Landing Pages, and websitess for both business and consumer use. <br/>
            I'm naturally curious, and continuously working on improving my skills one project at a time.</p> <br/>
            When I'm not working on code, you can fine me with my family at the Zoo, on the mats working on my Jiu-jitsu 
        </div>
    )
}